// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--1IB-Y","title":"_0fce717cdb--title--2SkJ4","link":"_0fce717cdb--link--2ZtX5","consultant-img":"_0fce717cdb--consultant-img--2fVsp"};